export default __webpack_public_path__ + "static/media/pizza-portrait.7daa07bc.jpg";